import reducer from './reducers';

import * as ArchiveSelectors from './selectors';
import * as ArchiveOperations from './operations';
import * as ArchiveTypes from './types';

export { ArchiveSelectors, ArchiveOperations, ArchiveTypes };

export default reducer;
